import buttonCss from 'components/styles/button';
import { useTranslation } from 'react-i18next';
import { colors } from 'components/styles/variables';
import { trackReturnToSeachClick } from 'lib/Tracking/FavoritesPage';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface Props {
  href: string;
  onClick?: (e: React.SyntheticEvent) => void;
}

export default function ReturnToLastSearch({ href, onClick }: Props): JSX.Element {
  const router = useRouter();

  useEffect(() => {
    const handleStart: any = async (url: string) => {
      if (window && url.indexOf('listings') > 0) {
        await trackReturnToSeachClick(url);
      }
    };
    const handleComplete: any = () => {};
    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    // Cleanup event listeners
    return (): void => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [router]);

  const { t } = useTranslation();
  const urlOnClick = async (e: React.MouseEvent): Promise<void> => {
    e.persist();
    e.target.dispatchEvent(e.nativeEvent);
  };

  return (
    <div className="return-to-search">
      <h3>{t('favorites.favoriteVehicles')}</h3>
      <p>{t('favorites.description')}</p>
      <a href={href} className="button" onClick={!onClick ? urlOnClick : onClick}>
        {t('favorites.returnToLastSearch')}
      </a>
      <style jsx>{buttonCss}</style>
      <style jsx>{`
        .return-to-search {
          width: 360px;
          box-sizing: border-box;
          padding: 20px 24px 24px 24px;
          background-color: white;
          border-radius: 8px;
          letter-spacing: 0.2px;
        }

        h3 {
          color: ${colors.BLACK};
          font-size: 20px;
          margin: 0 0 8px 0;
          font-weight: 600;
        }

        p {
          margin: 0 0 35px 0;
          color: ${colors.G3};
          line-height: 24px;
          font-size: 16px;
          font-weight: 300;
        }

        .button {
          width: 182px;
          height: 44px;
          box-sizing: border-box;
          padding: 9px 18px 11px 18px;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 400;
        }
      `}</style>
    </div>
  );
}
